import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import Typography from "@/shared/components/Typography/Typography";

import styles from "./Badge.module.scss";

const Badge = ({ number, className, classNameText, children }) => {
  let realNumber = number;
  // TODO: WORKAROUND need valid fix of api EGWW-2627
  if (number && typeof number === "object" && number?.count > -1) {
    realNumber = number.count;
  }
  if (typeof number !== "string" && isNaN(number)) {
    realNumber = 0;
  }
  return (
    <Typography
      className={classNames(styles["badge-wrap"], className)}
      tag="div"
      variant={Typography.variant.h6}
      letterSpacing={Typography.letterSpacing.sm}
      color={Typography.color.searchSectionPrimary}
    >
      <div className={classNames(styles["badge-text"], classNameText)}>
        {children ?? realNumber}
      </div>
    </Typography>
  );
};

Badge.propTypes = {
  number: PropTypes.any,
  children: PropTypes.any,
  className: PropTypes.string,
  classNameText: PropTypes.string,
};

export default Badge;
